import React, { useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "./TravelArranagementsMidBanner.css";
import "../../Coporate-travel-management/TravelServices/TravelServices.css";
import Modal from "../../../Pages/ModalForm";
import Heading from "../../../utls/Heading";
const TravelArranagementsMidBanner = () => {
  const [showModal, setShowModal] = useState(false);

  const handleShow = () => {
    setShowModal(true);
  };
  const handleClose = () => setShowModal(false);
  return (
    <>
      <section className="ta-midbanner position-relative">
        <div className="container">
          <div className="row py-4">
            <div className="col-md-6">
              <Heading className="headings text-white mt-2 ">
                <span>Travel with Confidence:</span> Stay Ahead with Safety
                Updates
              </Heading>
              <p className="text-white ta-p m-0 p-0">
                Manage your trips comfortably while staying updated on the
                latest safety protocols with Blueberry Travel.
              </p>
              <div className="carouselCaption mt-md-3 mt-xxl-3 upgrade-btn">
                <button
                  className="btn fs4 fw-bold bg-transparent text-white text-uppercase leeter"
                  type="submit"
                  onClick={handleShow}
                >
                  GET STARTED NOW
                </button>
              </div>
              <Modal show={showModal} handleClose={handleClose} />
            </div>
            <div className="col-md-6">
              <div className="travelmidimg  d-flex justify-content-center align-items-center">
                <LazyLoadImage
                  src="https://blueberrywebsites.azureedge.net/bbt/images/Blackman.png"
                  alt=""
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TravelArranagementsMidBanner;
